setAnonymousUserEmailPreferencesProcessing